import $ from 'jquery'
import 'bootstrap/js/dropdown'

$(() => {
  $('.dropdown-toggle').dropdown()
})
